import * as React from 'react';
import DeleteConfirmation from "../../Components/DeleteConfirmation";

function DeleteVenture(props) {
    return (
        <DeleteConfirmation
            id={props.id}
            title={'Usuń kontrakt'}
            subtitle={'Czy na pewno chcesz usunąć dane tego kontraktu?'}
            url={'/api/venture'}
            onSuccess={props.onSuccess}
        />
    )
}

export default DeleteVenture;